FOURTEEN_MONTHS_PLAN_SKUS